const interfacePhrases = {
    rate_limited: 'تجاوز معدل الطلبات',
    limit_exceeded: 'تجاوز الحد',
    used: 'استخدام',
    identifier: 'المعرّف',
    verification: 'التحقق',
    messages: 'الرسائل',
    data: 'البيانات',
    custom: 'مخصص',
    management_api: 'واجهة إدارة {{product}}',
    management_api_role_description: 'يمنح هذا الدور المدمج صلاحية الوصول إلى واجهة الإدارة.',
    client_credentials: 'بيانات اعتماد العميل',
    authentication_request: 'طلب المصادقة',
    callback: 'رد اتصال المصادقة',
    help_title: 'مركز مساعدة iden',
    help_subtitle: 'إرشادات دون مغادرة مساحة عملك',
    open_help: 'فتح صفحة المساعدة الكاملة',
    close_help: 'إغلاق المساعدة',
    about: 'حول المنتج والمصادر المفتوحة',
    open_navigation: 'فتح التنقل',
    close_navigation: 'إغلاق التنقل',
    development_enabled: 'تم تفعيل ميزات التطوير',
    beta: 'تجريبي',
    impersonation: 'انتحال هوية المستخدم',
    key: 'المفتاح',
    value: 'القيمة',
    error: 'خطأ',
    details: 'التفاصيل التقنية',
    callback_failed: 'تعذر إكمال رد اتصال تسجيل الدخول.',
    back_sign_in: 'العودة إلى تسجيل الدخول',
    powered_by: 'بدعم من',
    avatar: 'الصورة الرمزية',
    logo: 'الشعار',
    qr_code: 'رمز الاستجابة السريعة',
    sample_title: 'هل تريد مشاهدة مثال؟',
    sample_description: 'استكشف تطبيقًا نموذجيًا يستخدم هذا الدليل.',
    sample_action: 'عرض المثال',
    further_readings: 'قراءات إضافية',
    complete_guide: 'الدليل الكامل',
    custom_domains_notice: 'بعد إضافة <a>نطاقات مخصصة</a>، يمكنك استخدام نقطة النهاية التالية: <code>{{endpoint}}</code>.',
    my_project: 'مشروعي',
    my_secret: 'سري',
    my_token: 'رمزي',
    role_example: 'قارئ',
    reset_retry: 'إعادة ضبط الإعدادات والمحاولة مجددًا',
    open_dev_panel: 'فتح لوحة المطور',
    close_dev_panel: 'إغلاق لوحة المطور',
    configuration: 'الإعدادات',
    app_id: 'معرّف التطبيق',
    extra_parameters: 'معلمات تسجيل الدخول الإضافية',
    prompt: 'طلب المصادقة',
    scope: 'النطاق',
    resource: 'المورد',
    resources_space_delimited: 'الموارد (مفصولة بمسافات)',
    sign_out_to_apply: 'سجّل الخروج لتطبيق التغييرات.',
    refresh_token_grant: 'التفويض برمز التحديث',
    organization_id: 'معرّف المؤسسة',
    console_result: 'اطّلع على النتيجة في وحدة تحكم المتصفح.',
    request_token: 'طلب رمز',
    user_info: 'معلومات المستخدم',
    get_id_token_claims: 'جلب مطالبات رمز الهوية',
    fetch_user_info: 'جلب معلومات المستخدم',
    device_initializing: 'جارٍ تهيئة تفويض الجهاز…',
    device_success: 'لقد سجّلت الدخول إلى التطبيق التجريبي بنجاح.',
    sign_in_information: 'معلومات تسجيل دخولك:',
    email: 'البريد الإلكتروني',
    username: 'اسم المستخدم',
    user_id: 'معرّف المستخدم',
    sign_out_demo: 'تسجيل الخروج من التطبيق التجريبي',
    device_expired: 'انتهت صلاحية رمز الجهاز',
    generic_error: 'حدث خطأ',
    device_expired_description: 'انتهت صلاحية رمز الجهاز. حاول مجددًا للحصول على رمز جديد.',
    sign_in_title: 'سجّل الدخول إلى حسابك',
    scan_instruction: 'امسح رمز الاستجابة السريعة أو افتح هذا العنوان على جهاز آخر:',
    one_time_code: 'أدخل الرمز المخصص للاستخدام مرة واحدة',
    token_info: 'معلومات الرمز',
    get_access_token: 'جلب رمز الوصول',
    context_unavailable: 'تعذر تحميل معلومات الحساب.',
    not_initialized: 'لم تتم تهيئة معلومات الحساب.',
    not_set: 'غير محدد',
    configured: 'تم الإعداد',
    password: 'كلمة المرور',
    phone: 'رقم الهاتف',
    search_help: 'البحث في المساعدة',
    language: 'اللغة',
    menu: 'القائمة',
    compatibility_notice: 'ملاحظة التوافق: تبقى أسماء حزم تطوير البرامج والحزم والبروتوكولات والمكونات وترويسات الطلبات الموروثة من Logto دون تغيير.',
    source: 'المصدر',
    upstream_repository: 'المستودع الأصلي',
    current_fork: 'المستودع الحالي',
    license_notice: 'يعتمد iden على Logto، وهو برنامج مفتوح المصدر مرخّص بموجب رخصة موزيلا العامة 2.0.',
    about_description: 'معلومات المنتج ونسب المصادر المفتوحة.',
    page_not_found: 'الصفحة غير موجودة',
    page_not_found_description: 'هذه الصفحة غير متاحة. عد إلى مركز المساعدة للمتابعة.',
    introduction: 'مقدمة',
    quick_starts: 'البدء السريع',
    integration: 'التكامل',
    end_user_flows: 'مسارات المستخدم النهائي',
    authorization: 'التفويض',
    user_management: 'إدارة المستخدمين',
    security: 'الأمان',
    customization: 'التخصيص',
    connectors: 'الموصلات',
    organizations: 'المؤسسات',
    self_hosting: 'الاستضافة الذاتية',
    continue: 'متابعة',
    loading: 'جارٍ التحميل…',
    save: 'حفظ',
    saved: 'تم الحفظ',
    try_again: 'المحاولة مجددًا',
    client_id: 'معرّف العميل',
    client_secret: 'سر العميل',
    redirect_uri: 'عنوان إعادة التوجيه',
    status: 'الحالة',
    type: 'النوع',
    permissions: 'الأذونات',
    token_data: 'بيانات الرمز',
    context_data: 'بيانات السياق',
    jwt_extra_claims: 'مطالبات الرمز الإضافية',
    action_result: 'نتيجة الإجراء',
    social_account_already_linked: 'هذا الحساب الاجتماعي مرتبط بالفعل.',
};
export default Object.freeze(interfacePhrases);
